import { render, staticRenderFns } from "./SchoolFacialDeviceStaffModal.vue?vue&type=template&id=6b8494f0&scoped=true&"
import script from "./SchoolFacialDeviceStaffModal.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialDeviceStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8494f0",
  null
  
)

export default component.exports